import { RichText } from 'src/components/RichText/RichText';
import React from 'react';
import { useQuery } from '@apollo/client';
import { useDeps } from 'src/hooks/useDeps';
import Bugsnag from '@bugsnag/js';

import { cmsBlocks, cmsBlocksVariables } from '../../queries/__generated__/cmsBlocks';
import getCmsBlocks from '../../queries/getCmsBlocks.graphql';

type Props = {
    className?: string;
};

export const DeliveryTab: React.FC<Props> = ({ className }) => {
    const { error, loading, data } = useQuery<cmsBlocks, cmsBlocksVariables>(getCmsBlocks, {
        variables: { identifiers: ['delivery_information_tab'] },
        ssr: useDeps().env.SSR_GQL,
    });

    if (error) {
        Bugsnag.notify(error);
        return null;
    }
    if (loading) return null;
    if (!data) return null;
    if (!data.cmsBlocks) return null;
    if (!Array.isArray(data.cmsBlocks.items)) return null;

    const deliveryInfo = data.cmsBlocks.items[0]?.content;

    return <RichText className={className} content={deliveryInfo || 'missing content'} />;
};
